import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { StyledBlackInformationTypography } from "../../../../components/commonComponents/StyledComponents/styled";
import { Box } from "@mui/material";
import ActionButton from "../../../../components/commonComponents/Buttons/ActionButton";
import { Add } from "@mui/icons-material";
import NewWorkspaceSection from "./NewWorkspaceSection";
import { archiveWorkspaceSection } from "../../../../api_calls/WorkspaceSections";
import Confirmation from "../../../../components/commonComponents/ConfirmationBox/Confirmation";
import { toast } from "react-toastify";
import SectionsList from "./SectionsList";

const AvailableWorkspaceSection = () => {
    const currentStateData = useSelector((state) => state.userSelections);
    const dispatchAction = useDispatch();
    const [newSectionPopup, setNewSectionPopup] = React.useState(false);

    return (
        <>
            <Box height={10} />
            <StyledBlackInformationTypography variant="body2" sx={{ marginLeft: 0 }}>
                Changes made here apply across the entire workspace.
            </StyledBlackInformationTypography>
            <Box height={5} />
            <StyledBlackInformationTypography variant="body2" sx={{ marginLeft: 0, fontWeight: "normal" }}>
                Editing existing sections will also update those sections in already published brand reports - provided they are set to visible. Adding a new performance section has no impact on already published reports.
            </StyledBlackInformationTypography>
            <Box height={2} />
            <StyledBlackInformationTypography variant="body2" sx={{ marginLeft: 0, fontWeight: "normal" }}>
                If a section is no longer needed, you can archive it. Archiving hides the section from future reports but does not remove it from reports that have already been published.
            </StyledBlackInformationTypography>
            <Box height={2} />
            <StyledBlackInformationTypography variant="body2" sx={{ marginLeft: 0, fontWeight: "normal" }}>
                To permanently remove a section from all reports, including those already published, you must delete the archived section.
            </StyledBlackInformationTypography>
            {/* <Box height={2} /> */}
            <ActionButton
                onClick={(e) => {
                    e.preventDefault();
                    setNewSectionPopup(true);
                }}
                label={"New Section"}
                icon={<Add />}
            />

            {/* --------- workspace sections list ----------- */}
            <Box height={10} />
            <SectionsList listType={"available"} sectionType={"performance"} />

            {/* --------- new section popup ----------- */}
            {
                newSectionPopup === true && (
                    <NewWorkspaceSection
                        showModal={newSectionPopup}
                        sectionType={"performance"}
                        usedFor="add"
                        closeModal={() => {
                            setNewSectionPopup(false);
                        }}
                    />
                )
            }

        </>
    );
};

export default AvailableWorkspaceSection;
